export const extractGamesAppChannel = (userAgent: string) =>
  userAgent.match(/WTChannel\/([^\s]+)/)?.[1] ?? undefined;
